// VirtualButtons.js - 虚拟按键组件
export default class VirtualButtons {
    constructor(scene) {
        this.scene = scene;
        this.buttons = {};
        this.callbacks = {};
        
        this.createButtons();
    }
    
    createButtons() {
        const { width, height } = this.scene.cameras.main;
        
        // 按钮尺寸（缩小）
        const buttonRadius = 24;
        const buttonSpacing = 55; // 按钮之间的间距
        
        // 确认按钮（右侧，对应空格键）
        const confirmX = width - 60;
        const confirmY = height - 60;
        this.createButton('confirm', confirmX, confirmY, buttonRadius, '确认', 0xff0000);
        
        // 菜单按钮（右侧，确认按钮上方）
        const menuX = width - 60;
        const menuY = height - 60 - buttonSpacing;
        this.createButton('menu', menuX, menuY, buttonRadius, '菜单', 0xff0000);
        
        // 上/下车按钮（右侧，菜单按钮上方）
        const vehicleX = width - 60;
        const vehicleY = height - 60 - buttonSpacing * 2;
        this.createButton('vehicle', vehicleX, vehicleY, buttonRadius, '上下车', 0xff0000);
    }
    
    createButton(key, x, y, radius, label, color) {
        // 创建按钮背景
        const button = this.scene.add.circle(x, y, radius, color, 0.7);
        button.setScrollFactor(0);
        button.setDepth(10000);
        button.setInteractive({ useHandCursor: true });
        
        // 创建按钮文字（根据按钮大小调整字体）
        const fontSize = radius <= 40 ? '12px' : '14px';
        const text = this.scene.add.text(x, y, label, {
            fontSize: fontSize,
            fill: '#ffffff',
            fontFamily: 'monospace',
            align: 'center'
        });
        text.setOrigin(0.5);
        text.setScrollFactor(0);
        text.setDepth(10001);
        
        // 添加点击效果
        button.on('pointerdown', () => {
            // 按下效果
            button.setAlpha(0.5);
            this.scene.tweens.add({
                targets: button,
                alpha: 0.7,
                duration: 100,
                ease: 'Power2'
            });
            
            // 触发回调
            if (this.callbacks[key]) {
                this.callbacks[key]();
            }
        });
        
        // 存储按钮对象
        this.buttons[key] = {
            button: button,
            text: text
        };
    }
    
    setCallback(key, callback) {
        this.callbacks[key] = callback;
    }
    
    setVisible(visible) {
        Object.values(this.buttons).forEach(btn => {
            btn.button.setVisible(visible);
            btn.text.setVisible(visible);
        });
    }
    
    destroy() {
        Object.values(this.buttons).forEach(btn => {
            if (btn.button) btn.button.destroy();
            if (btn.text) btn.text.destroy();
        });
        this.buttons = {};
        this.callbacks = {};
    }
}

